export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8607.5c149789.jpg";